// Store do tenant — branding dinâmico via API (White Label Fase 4)
import { signal } from '@preact/signals';

export interface TenantBranding {
  name: string;
  slug: string;
  logo_url: string | null;
  logo_dark_url: string | null;
  favicon_url: string | null;
  primary_color: string;
  accent_color: string;
  bg_color: string;
  custom_css: string | null;
  features_json: string;
}

export const tenantBranding = signal<TenantBranding | null>(null);
export const tenantLoaded = signal(false);

export async function fetchTenantBranding() {
  try {
    const res = await fetch('/api/v1/tenant/branding');
    if (res.ok) {
      const data = await res.json();
      tenantBranding.value = data.data || data;
      applyTenantBranding(tenantBranding.value);
    }
  } catch (e) {
    console.error('[tenant] Erro ao carregar branding:', e);
  } finally {
    tenantLoaded.value = true;
  }
}

function applyTenantBranding(b: TenantBranding | null) {
  if (!b) return;
  const root = document.documentElement;

  // Aplicar cores como CSS variables (complementa o sistema de temas existente)
  if (b.primary_color) root.style.setProperty('--primary', b.primary_color);
  if (b.accent_color) root.style.setProperty('--accent', b.accent_color);
  if (b.bg_color) root.style.setProperty('--bg', b.bg_color);

  // Atualizar título da página
  if (b.name) document.title = b.name;

  // Atualizar favicon
  if (b.favicon_url) {
    const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (link) link.href = b.favicon_url;
  }

  // Injetar custom CSS do tenant
  if (b.custom_css) {
    let style = document.getElementById('tenant-custom-css');
    if (!style) {
      style = document.createElement('style');
      style.id = 'tenant-custom-css';
      document.head.appendChild(style);
    }
    style.textContent = b.custom_css;
  }
}
